import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import UserApi from "../services/userApi";
import {
    RAISE_QUERY_ADMIN_ROLE_RESPONSE,
    RAISE_QUERY_ADMIN_ROLE_FAILED,

} from '../redux/types/addUser';
let api = new UserApi();

export function* RaiseQueryAdminRole({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.RaiseQueryAdminRole(payload);
        console.log("data", data);
        if (data.success) {
            let responseData = data.data;
            if (responseData.roleList) {
                responsePayload.roleList = responseData.roleList
            }
            else {
                responsePayload = responseData
            }
            responsePayload.roleList = responseData.roleList
            yield put({ type: RAISE_QUERY_ADMIN_ROLE_RESPONSE, payload: responsePayload, })
            resolve && resolve(data.data)
        }
        else {
            resolve && resolve(data)
            yield put({ type: RAISE_QUERY_ADMIN_ROLE_FAILED, payload: data })
        }
    } catch (e) {
        yield put({ type: RAISE_QUERY_ADMIN_ROLE_FAILED, payload: responsePayload })

    }
}